// icons
import { MdEventNote } from "react-icons/md";

const agendaDiariaTecnico = {
  id: 'agenda-diaria-tecnico-group',
  type: 'group',
  roles: [1,200],
  breadcrumbs: false,
  children: [
    {
      id: 'agenda-diaria-tecnico',
      title: "Agenda Diaria Técnico",
      type: 'item',
      breadcrumbs: false,
      icon: MdEventNote,
      url: '/agenda-diaria-tecnico'
    }
  ]
};

export default agendaDiariaTecnico;
